export default __webpack_public_path__ + "static/media/onboard-identity.d1747cd4.svg";